import { render } from "./SharedTranscriptView.vue?vue&type=template&id=a0b12112"
import script from "./SharedTranscriptView.vue?vue&type=script&lang=js"
export * from "./SharedTranscriptView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__